import { useMemo } from 'react';
import { getSession } from '../requests.mjs';
import useResult from '../response';

export default function useGetSession(auth, clientId, sessionId) {
  const request = useMemo(function () {
    return getSession(auth, clientId, sessionId);
  }, []);
  return useResult(request);
}
